import { render, staticRenderFns } from "./GridTemplate.vue?vue&type=template&id=4b28066a&"
import script from "./GridTemplate.vue?vue&type=script&lang=js&"
export * from "./GridTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports